import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const PrivacyShieldTermsOfService = lazy(
  () => import('pages/terms-of-service/privacy-shield'),
);

const PrivacyShieldPrivacyPolicy = lazy(
  () => import('pages/privacy-policy/privacy-shield'),
);

const PRIVACY_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'component',
    render: () => (
      <Suspense fallback={<Spin />}>
        <PrivacyShieldPrivacyPolicy />
      </Suspense>
    ),
  },
  termsOfService: {
    kind: 'component',
    render: () => (
      <Suspense fallback={<Spin />}>
        <PrivacyShieldTermsOfService />
      </Suspense>
    ),
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'cyex',
  vaultProject: 'privacy_shield',
  adaChat: true,
  accountDetails: true,
  secureUpload: false,
  plan: true,
  security: true,
  missingPII: true,
  finishSetup: true,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'CyEx, LLC',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: null,
  carouselBanners: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      active: true,
      customerSupport: true,
      availability: (
        <>
          Monday - Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default PRIVACY_BRAND_CONFIG;
